module.exports = __webpack_public_path__ + "static/img/scan-wx.423e0d9b.png";